import React from 'react';
import { TopToolbar, RefreshButton, Button } from 'react-admin';
import { Link } from 'react-router-dom';
import ContentAdd from '@material-ui/icons/Add';

const BusinessContractRouteListActions = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
	total,
    id,
    translate,
    businessContractId
}) => (
    <TopToolbar>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        <Button
            component={Link}
            to={{
                pathname: `${basePath}/create`,
                state: {
                    record: {
                        businessContractId,
                    },
                },
            }}
            label="Create"
            variant="text"
        >
            <ContentAdd />
        </Button>
        <RefreshButton />
    </TopToolbar>
);

export default BusinessContractRouteListActions;
